import * as Fancyapps from '@fancyapps/ui';

export default {
	init() {
		Fancyapps.Fancybox.bind('[data-fancybox]');
	},
};
